import { RegisterDiagram } from '@core/entities/register/RegisterDiagram'
import { SiteBoxDocument } from '@core/entities/SiteBoxDocument/SiteBoxDocument'
import { Proof } from '@core/entities/template/TemplateQuestion'
import PSPDFKitImport, { Instance } from 'pspdfkit'

export const siteBoxDocumentToProof = (doc: SiteBoxDocument): Proof => ({
  id: doc.id,
  key: doc.currentVersion?.documentKey,
  siteBoxDocumentVersionId: doc.currentVersion?.id,
  type: doc.currentVersion?.getMimeType() ?? 'application/pdf',
  downloadUrl: doc.currentVersion?.documentDownloadUrl,
  getUrl: doc.currentVersion?.documentGetUrl,
  name: doc.name,
  siteBoxDocument: doc,
})

export type PspdfkitData = {
  instance: Instance
  PSPDFKit: typeof PSPDFKitImport
}
export type PSPDFKitDocumentAnnotationSidebarProps = {
  documents: RegisterDiagram[]
  renderDocumentOptions: (document: RegisterDiagram) => {
    title: string
    onSelect: () => void
  }
  document: RegisterDiagram
}
